/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { PublicUserPermissionAssignmentDto } from './PublicUserPermissionAssignmentDto';

export type PublicUserUpdateDto = {
    /**
     * Authorized authentication type of the user
     */
    authTypes?: Array<'SAML2' | 'LOGIN_PASSWORD'>;
    /**
     * Name of the user
     */
    name: string;
    /**
     * Domain access permissions of the user
     */
    permissions?: Array<PublicUserPermissionAssignmentDto>;
    /**
     * System role of the user
     */
    role: PublicUserUpdateDto.role;
};

export namespace PublicUserUpdateDto {

    /**
     * System role of the user
     */
    export enum role {
        ADMIN = 'ADMIN',
        EDITOR = 'EDITOR',
        VIEWER = 'VIEWER',
    }


}
